import React from "react";

import { Device } from "@devices/types";

import { buildInstalledPackageIndex, InstalledPackageIndex } from "./groupApkStatus";

type GroupDevicesContextType = {
    devices: Device[];
    installedPackages: InstalledPackageIndex;
};

const emptyDevices: Device[] = [];

const GroupDevicesContext = React.createContext<GroupDevicesContextType>({
    devices: emptyDevices,
    installedPackages: buildInstalledPackageIndex(emptyDevices),
});

/**
 * Shares one package index with every version row. The rows for older versions are rendered outside the
 * TanStack cell context, so they cannot read the table's `meta` and need a context instead.
 */
export const GroupDevicesProvider = ({ devices, children }: React.PropsWithChildren<{ devices: Device[] }>) => {
    const value = React.useMemo(() => ({ devices, installedPackages: buildInstalledPackageIndex(devices) }), [devices]);

    return <GroupDevicesContext.Provider value={value}>{children}</GroupDevicesContext.Provider>;
};

export const useGroupDevices = () => React.useContext(GroupDevicesContext);
